// src/components/common/ThemeToggle.js - Component for toggling between light and dark themes
import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
`;

const ToggleButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: 20px;
  transition: all var(--transition-speed) ease;
  min-width: 60px;
  height: 32px;
  position: relative;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:focus {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }
`;

const ToggleLabel = styled.span`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <ToggleContainer>
      <ToggleLabel>
        {theme === 'light' ? 'Light' : 'Dark'}
      </ToggleLabel>
      <ToggleButton 
        onClick={toggleTheme} 
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        title={`Currently in ${theme} mode. Click to switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      >
        {theme === 'light' ? '🌙' : '☀️'}
      </ToggleButton>
    </ToggleContainer>
  );
};

export default ThemeToggle; 